import { motion } from "framer-motion";
import { MessageCircle, ClipboardCheck, FileText, Hammer } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHeader } from "@/components/site/Reveal";

const ICONS = [MessageCircle, ClipboardCheck, FileText, Hammer];

export const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section id="process" className="py-24 sm:py-32 relative" data-testid="process-section">
      <div className="container-x">
        <SectionHeader tag={t.process.tag} title={t.process.title} />
        <div className="relative mt-16">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {t.process.steps.map((step, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={i}
                  data-testid={`process-step-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  className="relative"
                >
                  <div className="relative z-10 grid place-items-center h-20 w-20 rounded-2xl bg-[#1C2539] border border-white/10 mb-6">
                    <Icon className="h-8 w-8 text-[#FF8C42]" />
                    <span className="absolute -top-3 -right-3 grid place-items-center h-8 w-8 rounded-full bg-[#E85D04] text-white font-display font-extrabold text-sm">
                      {i + 1}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-xl">{step.title}</h3>
                  <p className="text-[#9CA3AF] text-sm mt-2.5 leading-relaxed">{step.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
